export default "<a data-id=\"{{id}}\" class=\"list-group-item\" data-dismiss=\"modal\">\n    {{name}}\n</a>";